import { isEmpty, mapValues, omit, without } from '@sama/micro-dash';
import { ShapeGroupState } from '../../../state/shape-group-state';

export function removeShapesFromGroups(
  groups: StrictRecord<ShapeGroupState['index'], ShapeGroupState>,
  shapeIndexes: number[],
) {
  const indexesOfEmptyGroups: number[] = [];
  const groupsWithUpdatedShapeIndexes = mapValues(groups, (group) => {
    // @ts-ignore -- fix me
    const updatedShapeIndexes = without(group.shapeIndexes, ...shapeIndexes);

    if (isEmpty(updatedShapeIndexes)) {
      // @ts-ignore -- fix me
      indexesOfEmptyGroups.push(group.index);
    }

    return { ...group, shapeIndexes: updatedShapeIndexes };
  });

  return omit(groupsWithUpdatedShapeIndexes, ...indexesOfEmptyGroups);
}
